import { ArticleContainer } from '../../model3d/article-container';

export class DrillingHoleSizeData {
  public container: ArticleContainer;
  public offset: number;
  public width: number;

  constructor(container: ArticleContainer, offset: number, width: number) {
    this.container = container;
    this.offset = offset;
    this.width = width;
  }

  public get start(): number {
    return this.offset + this.width / 2;
  }

  public get end(): number {
    return this.offset - this.width / 2;
  }
}
